import LocalizedStrings from "react-localization";
import LocalText from "src/local";

const localizationStrings = new LocalizedStrings({
  ja: {
    label: LocalText.screens.authPasswordReset.confirmLayout.label,
    inputCodePlaceholder:
      LocalText.screens.authPasswordReset.confirmLayout.inputCodePlaceholder,
    inputPasswordPlaceholder:
      LocalText.screens.authPasswordReset.confirmLayout
        .inputPasswordPlaceholder,
    inputPasswordConfirmPlaceholder:
      LocalText.screens.authPasswordReset.confirmLayout
        .inputPasswordConfirmPlaceholder,
    inputCodelValidationRequire:
      LocalText.screens.authPasswordReset.confirmLayout
        .inputCodelValidationRequire,
    inputPasswordValidationRequire:
      LocalText.screens.authPasswordReset.confirmLayout
        .inputPasswordValidationRequire,
    inputPasswordConfirmValidationRequire:
      LocalText.screens.authPasswordReset.confirmLayout
        .inputPasswordConfirmValidationRequire,
    btnConfirm: LocalText.screens.authPasswordReset.confirmLayout.btnConfirm,
    processedDialogTitle:
      LocalText.screens.authPasswordReset.confirmLayout.processedDialogTitle,
    processedDialogBtnOK:
      LocalText.screens.authPasswordReset.confirmLayout.processedDialogBtnOK,
  },
});

export { localizationStrings };
